import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Navigation.css';

const Navigation = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('ig_language') || 'en';
    i18n.changeLanguage(savedLanguage);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('ig_language', lang);
  };

  const handleLogout = () => { logout(); navigate('/'); setMenuOpen(false); };

  const goToDashboard = () => {
    if (!user?.plan) { navigate('/plans'); return; }
    if (user.plan === 'basic') navigate('/basic-dashboard');
    else if (user.plan === 'premium') navigate('/premium-dashboard');
    else navigate('/enterprise-dashboard');
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="nav-brand" onClick={() => setMenuOpen(false)}>
          <span className="brand-icon">🕌</span>
          <span className="brand-text">{t('app_name')}</span>
        </Link>

        <div className="nav-right">
          <div className="language-switcher">
            <button className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`} onClick={() => changeLanguage('en')}>EN</button>
            <button className={`lang-btn ${i18n.language === 'fr' ? 'active' : ''}`} onClick={() => changeLanguage('fr')}>FR</button>
          </div>
          <div className="auth-buttons">
            {isAuthenticated ? (
              <>
                <button onClick={goToDashboard} className="btn-signup">Dashboard</button>
                <button onClick={handleLogout} className="btn-logout">{t('nav_logout')}</button>
              </>
            ) : (
              <>
                <Link to="/signin" className="btn-signin">{t('nav_signin')}</Link>
                <Link to="/plans" className="btn-signup">{t('nav_signup')}</Link>
              </>
            )}
          </div>
        </div>

        <button className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>

      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <div className="mobile-lang">
          <button className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`} onClick={() => changeLanguage('en')}>EN</button>
          <button className={`lang-btn ${i18n.language === 'fr' ? 'active' : ''}`} onClick={() => changeLanguage('fr')}>FR</button>
        </div>
        <div className="mobile-auth-btns">
          {isAuthenticated ? (
            <>
              <button onClick={goToDashboard} className="btn-signup mobile-full">Dashboard</button>
              <button onClick={handleLogout} className="btn-logout mobile-full">{t('nav_logout')}</button>
            </>
          ) : (
            <>
              <Link to="/signin" className="btn-signin mobile-full" onClick={() => setMenuOpen(false)}>{t('nav_signin')}</Link>
              <Link to="/plans" className="btn-signup mobile-full" onClick={() => setMenuOpen(false)}>{t('nav_signup')}</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
